import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupAnioAcademicos } from '../AnioAcademico/LookupAnioAcademicos';

registerLocale('es', es);

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class UpdatePeriodoExamen extends Component {
  static displayName = UpdatePeriodoExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      descripcion: '',
      errorMessage: '',
      redirect: false,
      showLookupAnios: false,
      startDate: new Date(),
      endDate: new Date(),
      llamado: '',
      anio: { anioAcademicoCod: 0, anioAcademicoDescripcion: '' },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWPeriodoExamen');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/pex/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos del período de examen.'
        ),
      });
      return;
    }

    this.setState({
      loadingInitial: false,
      anio: {
        anioAcademicoCod: data.returnModel.anioAcademicoCod,
        anioAcademicoDescripcion: data.returnModel.anioAcademicoDescripcion,
      },
      descripcion: data.returnModel.periodoExamenDescripcion.trim(),
      llamado: data.returnModel.periodoExamenLlamado.trim(),
      startDate: constantClass.parseApiDate(data.returnModel.periodoExamenFechaInicio),
      endDate: constantClass.parseApiDate(data.returnModel.periodoExamenFechaFin),
    });
  }

  handleShowAniosLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupAnios: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleDescripcionChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ descripcion: e.target.value });
  };

  handleLlamadoChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ llamado: e.target.value });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      anio: {
        anioAcademicoCod: anioProperties[0],
        anioAcademicoDescripcion: anioProperties[1],
      },
    });
  };

  handleStartDate = (date) => {
    this.clearFeedback();
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.clearFeedback();
    this.setState({ endDate: date });
  };

  isOkToSave() {
    return (
      this.state.descripcion.length > 0
      && this.state.llamado.length > 0
      && this.state.anio != null
      && this.state.anio.anioAcademicoDescripcion.length > 0
      && this.state.startDate != null
      && this.state.endDate != null
    );
  }

  areDatesOk() {
    const startDate = new Date(this.state.startDate);
    const endDate = new Date(this.state.endDate);
    return endDate > startDate;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;

    let errorMessage = '';
    const datesOk = this.areDatesOk();
    const isOkToSave = this.isOkToSave();

    if (!isOkToSave) {
      errorMessage = 'Todos los campos son obligatorios';
    }

    if (!datesOk) {
      if (errorMessage.length > 0) {
        errorMessage = errorMessage + ', la fecha de inicio no puede ser posterior a la fecha de fin';
      } else {
        errorMessage = 'La fecha de inicio no puede ser posterior a la fecha de fin';
      }
    }

    if (isOkToSave && datesOk) {
      this.saveStudent();
    } else {
      this.setState({ errorMessage });
    }
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/pex', {
      method: 'POST',
      body: JSON.stringify({
        PeridoExamenCod: parseInt(this.state.id, 10),
        PeriodoExamenDescripcion: this.state.descripcion,
        PeriodoExamenLlamado: this.state.llamado,
        PeriodoExamenFechaInicio: constantClass.serializeDateForApi(this.state.startDate),
        PeriodoExamenFechaFin: constantClass.serializeDateForApi(this.state.endDate),
        AnioAcademicoCod: parseInt(this.state.anio.anioAcademicoCod, 10),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar el período de examen. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-pex" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      errorMessage,
      descripcion,
      llamado,
      anio,
      startDate,
      endDate,
      showLookupAnios,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly
      ? 'Ver datos de Período de Examen'
      : 'Modificar Período de Examen';

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-pex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-pex">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-pex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados del período de examen.'
            : 'Actualice los datos del período y guarde los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando período de examen, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pex-upd-descripcion">
                Período de Examen
              </label>
              <input
                id="pex-upd-descripcion"
                className="md-form-page__input"
                type="text"
                value={descripcion}
                placeholder="Ingrese período de examen"
                onChange={this.handleDescripcionChangeInput}
                disabled={isBusy || this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pex-upd-llamado">
                Llamado
              </label>
              <input
                id="pex-upd-llamado"
                className="md-form-page__input"
                type="text"
                value={llamado}
                placeholder="Ingrese llamado"
                onChange={this.handleLlamadoChangeInput}
                disabled={isBusy || this.isReadOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Año Académico</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowAniosLookup}
                  disabled={isBusy}
                >
                  Seleccione el Año Académico
                </button>
              ) : null}
              {showLookupAnios ? (
                <LookupAnioAcademicos
                  selectItem={this.handleSelectAnioItem}
                  hideLookup={this.handleHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={anio.anioAcademicoDescripcion}
                readOnly
                disabled
                aria-label="Año académico"
              />
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Inicio</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(startDate)}
                    disabled
                    readOnly
                    aria-label="Fecha de inicio"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="pex-upd-fecha-inicio">
                    Fecha de Inicio
                  </label>
                  <DatePicker
                    id="pex-upd-fecha-inicio"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={startDate}
                    onChange={this.handleStartDate}
                    disabled={isBusy}
                    dateFormat="dd/MM/yyyy"
                  />
                </>
              )}
            </div>

            <div className="md-form-page__field">
              {this.isReadOnly ? (
                <>
                  <span className="md-form-page__label">Fecha de Fin</span>
                  <input
                    className="md-form-page__input"
                    type="text"
                    value={constantClass.formatDisplayDate(endDate)}
                    disabled
                    readOnly
                    aria-label="Fecha de fin"
                  />
                </>
              ) : (
                <>
                  <label className="md-form-page__label" htmlFor="pex-upd-fecha-fin">
                    Fecha de Fin
                  </label>
                  <DatePicker
                    id="pex-upd-fecha-fin"
                    className="md-form-page__input"
                    locale="es"
                    closeOnScroll
                    selected={endDate}
                    onChange={this.handleEndDate}
                    disabled={isBusy}
                    dateFormat="dd/MM/yyyy"
                  />
                </>
              )}
            </div>

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
